import run1 from 'images/app-page/own-every-mile/screens/run/1.png'
import run2 from 'images/app-page/own-every-mile/screens/run/2.png'
import run3 from 'images/app-page/own-every-mile/screens/run/3.png'
import run4 from 'images/app-page/own-every-mile/screens/run/4.png'

import walk1 from 'images/app-page/own-every-mile/screens/walk/1.png'
import walk2 from 'images/app-page/own-every-mile/screens/walk/2.png'
import walk3 from 'images/app-page/own-every-mile/screens/walk/3.png'
import walk4 from 'images/app-page/own-every-mile/screens/walk/4.png'

import ride1 from 'images/app-page/own-every-mile/screens/ride/1.png'
import ride2 from 'images/app-page/own-every-mile/screens/ride/2.png'
import ride3 from 'images/app-page/own-every-mile/screens/ride/3.png'
import ride4 from 'images/app-page/own-every-mile/screens/ride/4.png'

import fitness1 from 'images/app-page/own-every-mile/screens/fitness/1.png'
import fitness2 from 'images/app-page/own-every-mile/screens/fitness/2.png'
import fitness3 from 'images/app-page/own-every-mile/screens/fitness/3.png'
import fitness4 from 'images/app-page/own-every-mile/screens/fitness/4.png'

import hike1 from 'images/app-page/own-every-mile/screens/hike/1.png'
import hike2 from 'images/app-page/own-every-mile/screens/hike/2.png'
import hike3 from 'images/app-page/own-every-mile/screens/hike/3.png'
import hike4 from 'images/app-page/own-every-mile/screens/hike/4.png'

const screens = {
  run: [run1, run2, run3, run4],
  walk: [walk1, walk2, walk3, walk4],
  ride: [ride1, ride2, ride3, ride4],
  fitness: [fitness1, fitness2, fitness3, fitness4],
  hike: [hike1, hike2, hike3, hike4],
}

export default screens
